export default __webpack_public_path__ + "static/media/page-not-found.1e125239.png";